import { FC } from 'react';
import { AllieStatsItem, AllieText } from '../../../components';
import { DataValueStatisticsProps } from './DataValueStatistics.types';
import {
  DataValueStatisticsContainer,
  DataValueStatisticsLabelContainer,
} from './DataValueStatistics.styles';

export const DataValueStatistics: FC<DataValueStatisticsProps> = ({
  title,
  subtitle,
  value,
  icon,
  disabled,
  isViewTv,
  iconSize = 24,
  variation,
  labelWidth,
  style,
}) => (
  <DataValueStatisticsContainer style={style}>
    <DataValueStatisticsLabelContainer width={labelWidth}>
      <AllieText color="neutral-80" type={title.type}>
        {title.label}
      </AllieText>
      {subtitle && (
        <AllieText color="neutral-50" type="body3" weight={500}>
          {subtitle}
        </AllieText>
      )}
    </DataValueStatisticsLabelContainer>
    <AllieStatsItem
      valueProps={{
        color: 'neutral-80',
        children: value,
        type: isViewTv ? 'body3' : 'h3',
      }}
      icon={icon}
      iconProps={{ style: { fontSize: `${iconSize}px` } }}
      variation={variation && { ...variation, textProps: { type: isViewTv ? 'field3' : 'body2' } }}
      disabled={disabled}
    />
  </DataValueStatisticsContainer>
);
